import React, { Component, Fragment } from 'react';
import Table from 'react-bootstrap/Table';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Card from 'react-bootstrap/Card';
import Image from 'react-bootstrap/Image';
import Form from 'react-bootstrap/Form';
import Container from 'react-bootstrap/Container';
import Popover from 'react-bootstrap/Popover';
import ToggleButtonGroup from 'react-bootstrap/ToggleButtonGroup';
import ToggleButton from 'react-bootstrap/ToggleButton';
import ButtonToolbar from 'react-bootstrap/ButtonToolbar';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Spinner from "react-bootstrap/Spinner"
import 'bootstrap/dist/css/bootstrap.min.css';
import Api from '../Api';
import Logo from "../Assets/ts-logo.png";
import moment from "moment"

export default class OrgPicks extends Component {

    constructor(props) {
        super(props)
        this.state = {
            currentBetType: '',
            availablePickTypes: null,
            // events: null,
            orgPicks: null,
            event_id: null,
            org: null,
            org_id: null,
            defaultToggleKey: 1,
            sport: null,
            eventFilter: true,
            record: true,
            daily: false,
            showTogglePickType: true,
            showTogglePickTypeQuery: false,
            show: "012",
            showTopics: "all",
            dates: [],
            selectedDate: moment().format("ll"),
            eventName: ""
        }
        // this.getFlatEventsWhereOrgAnalystParticipated = this.getFlatEventsWhereOrgAnalystParticipated.bind(this)
        this.getOrgEventPickTypes = this.getOrgEventPickTypes.bind(this)
        this.getOrgPicks = this.getOrgPicks.bind(this)
        this.getOrgSpreadPicks = this.getOrgSpreadPicks.bind(this)
        this.getOrgOUPicks = this.getOrgOUPicks.bind(this)
        this.getOrg = this.getOrg.bind(this)
        this.handleEventChange = this.handleEventChange.bind(this)
        this.updateBrowserState = this.updateBrowserState.bind(this)
        this.handleSpreadsClick = this.handleSpreadsClick.bind(this)
        this.handleOverUnderClick = this.handleOverUnderClick.bind(this)
        this.sortedAnalystNames = []
    }

    setTopicDates(topics) {
        let filteredTopics = []
        if (this.state.showTopics !== "all") {
            let topicCheck = this.state.showTopics.split(",")
            for (let topicId of Object.keys(topics)) {
                if (topicCheck.includes(topicId.slice(-4))) {
                    filteredTopics.push(topics[topicId])
                }
            }
        } else {
            filteredTopics = Object.values(topics)
        }

        const dates = filteredTopics.map(topic => moment(new Date(topic.game_start || topic.outcomeDate)).format("ll")).reduce(function (p, c, i, a) {
            if (!p.includes(c)) return p.concat(c)
            return p;
        }, [])

        this.setState({ dates, selectedDate: dates.includes(moment().format("ll")) ? moment().format("ll") : "all" })
    }


    handleStraightUpClick = () => {
        this.setState({
            defaultToggleKey: 1
        })
        this.getOrgPicks(this.state.event_id, this.state.org_id)
    }

    handleSpreadsClick = () => {
        this.setState({
            defaultToggleKey: 2
        })
        this.getOrgSpreadPicks(this.state.event_id, this.state.org_id)
    };

    handleOverUnderClick = () => {
        this.setState({
            defaultToggleKey: 3
        })
        this.getOrgOUPicks(this.state.event_id, this.state.org_id)
    }

    dateChangeHandler = (date) => {
        this.setState({ selectedDate: date })
    }


    /**
     * Updates the Browser's state and Url
     */
    updateBrowserState() {
        window.history.pushState(
            `current_sport_event_and_org`,
            `current_sport_event_and_org`,
            `/orgpicks/${this.state.sport}/${this.state.event_id}/${this.state.org_id}`
        )
    }

    async handleEventChange(e) {
        this.setState({
            orgPicks: null,
            availablePickTypes: null,
            event_id: e.target.value
        }, () => {
            this.getOrgPicks(this.state.event_id, this.state.org_id)
            this.getOrgEventPickTypes(this.state.event_id, this.state.org_id)
            this.updateBrowserState()
        })
    }

    async getOrgEventPickTypes(eventId, orgId) {
        try {
            const data = await Api.getOrgEventPickTypes(eventId, orgId)
            let show = Object.values(data)
            let truth = 0
            for (let type of show) {
                if (type === true) {
                    truth++
                }
            }
            let showTogglePickType = false
            if (truth > 1) {
                showTogglePickType = true
            }
            this.setState({
                availablePickTypes: data,
                showTogglePickType
            })
        } catch (e) {
            // console.log("An error occured: ", e)
        }
    }
    // async getFlatEventsWhereOrgAnalystParticipated(sport, org) {
    //     try {
    //         let events = await Api.getFlatEventsWhereOrgAnalystParticipated(sport, org)
    //         this.setState({
    //             events: events
    //         })
    //     } catch (e) {
    //         // console.log("An error occured: ", e)
    //     }
    // }

    async getOrgOUPicks(eventId, orgId) {
        try {
            this.setState({
                orgPicks: null,
                currentBetType: 'overUnder'
            }, async () => {
                const orgOUPicks = await Api.getOrgOUPicks(eventId, orgId);
                this.setState({
                    orgPicks: orgOUPicks,
                    eventName: orgOUPicks.name
                })
                this.setTopicDates(orgOUPicks.topics)
            })
        } catch (e) {
            // console.log("An error occured: ", e)
        }
    }
    async getOrgSpreadPicks(eventId, orgId) {
        try {
            this.setState({
                orgPicks: null,
                currentBetType: 'spread'
            }, async () => {
                const orgSpreadPicks = await Api.getOrgSpreadPicks(eventId, orgId);
                this.setState({
                    orgPicks: orgSpreadPicks,
                    eventName: orgSpreadPicks.name
                })
                this.setTopicDates(orgSpreadPicks.topics)
            })
        } catch (e) {
            // console.log("An error occured: ", e)
        }
    }
    async getOrgPicks(event_id, org_id) {
        try {
            this.setState({
                orgPicks: null,
                currentBetType: 'straightUp'
            }, async () => {
                let orgPicks = await Api.getOrgPicks(event_id, org_id)

                this.setState({
                    orgPicks: orgPicks,
                    eventName: orgPicks.name
                })
                this.setTopicDates(orgPicks.topics)
            })
        } catch (e) {
            // console.log("An error occured: ", e)
        }
    }

    async getOrg(org_id) {
        try {
            let org = await Api.getOrg(org_id)
            //console.log("org: ", org)
            this.setState({
                org: org
            })
        } catch (e) {
            // console.log("An error occured: ", e)
        }
    }

    generatePopPover(pick) {
        return (
            <Popover id="popover-basic">
                <Popover.Title className="popover-header" as="h4">
                    <span className="float-right" role="img" aria-label="">💬</span>
                    <small><strong>{pick.analystName.split(' ')[0]}'s take</strong></small>
                </Popover.Title>
                <Popover.Content>
                    "{pick.take}"
                    </Popover.Content>
            </Popover>
        )
    }
    processRowPick(pick, topic) {
        // If no pick for the analyst on this row
        if (!pick) {
            return (<td></td>)
        }
        return (
            <td key={topic.pathName} className="align-middle text-center">
                {this.generateStraightUpPickIcon(pick, topic)}
                {pick.take ? (
                    pick.take.trim().length > 0 ?
                        (
                            <OverlayTrigger trigger="click" placement="auto" rootClose overlay={this.generatePopPover(pick)}>
                                <span role="img" aria-label="">&nbsp;💬</span>
                            </OverlayTrigger>
                        ) : (<span />)

                ) : (<span />)
                }
            </td>
        )
    }

    displayPickBasedOnStatus(pick) {
        if (pick.correct) {
            return (
                <Image width="36"
                    src={pick.pickUrl}
                    style={{ objectFit: "cover" }}
                />
            )
        }
        return (<Image width="36"
            src={pick.pickUrl}
            className="opacity-50"
            style={{ objectFit: "cover" }}
        />)
    }

    /**
     * Generates the icon or text of a straight up pick depending on its status
     * @param {*} pick 
     */
    generateStraightUpPickIcon(pick, topic) {
        const analyst = this.state.orgPicks.analystRecords.find(e => e.id === pick.analystId)
        if (pick.resolved) {
            if (pick.tie) {
                return (
                    <span>
                        <a href={`https://tallysight.com/analyst/${analyst.username}/${this.state.sport}/${this.state.orgPicks.pathName}/pick/${topic.pathName}`} target="_blank" rel="noopener noreferrer">
                            <Image width="36" src={pick.pickUrl}
                                style={{ objectFit: "cover" }} />
                        </a>
                        <br></br>
                        <small className="number text-uppercase">
                            {pick.lock && <span>🔒</span>}
                            {pick.pickAbbrevation !== null && pick.pickAbbrevation !== undefined ? pick.pickAbbrevation : pick.pickName} {(pick.odds && pick.odds !== 0.1) ? ` (${pick.odds > 0 ? "+" : ""}${pick.odds})` : ""} (Tie)
                        </small>
                    </span >
                )
            }
            if (pick.correct) {
                return (
                    <span>
                        <a href={`https://tallysight.com/analyst/${analyst.username}/${this.state.sport}/${this.state.orgPicks.pathName}/pick/${topic.pathName}`} target="_blank" rel="noopener noreferrer">
                            <Image width="36"
                                src={pick.pickUrl}
                                style={{ objectFit: "cover" }}
                            />
                        </a>
                        <br></br>
                        <small className="number text-uppercase">
                            {pick.lock && <span>🔒</span>}
                            {pick.pickAbbrevation !== null && pick.pickAbbrevation !== undefined ? pick.pickAbbrevation : pick.pickName} {(pick.odds && pick.odds !== 0.1) ? ` (${pick.odds > 0 ? "+" : ""}${pick.odds})` : ""} <i className="fas fa-check-circle text-success"></i>
                        </small>
                    </span>
                )
            }
            // Incorrect pick
            return (
                <span>
                    <a href={`https://tallysight.com/analyst/${analyst.username}/${this.state.sport}/${this.state.orgPicks.pathName}/pick/${topic.pathName}`} target="_blank" rel="noopener noreferrer">
                        <Image width="36"
                            src={pick.pickUrl}
                            className="opacity-50"
                            style={{ objectFit: "cover" }}
                        />
                    </a>
                    <br></br>
                    <small className="text-muted text-uppercase number">
                        {pick.lock && <span>🔒</span>}
                        {pick.pickAbbrevation !== null && pick.pickAbbrevation !== undefined ? pick.pickAbbrevation : pick.pickName}
                        {(pick.odds && pick.odds !== 0.1) ? ` (${pick.odds > 0 ? "+" : ""}${pick.odds})` : ""}
                    </small>
                </span>
            )
        }
        // Unresolved pick
        return (
            <span>
                <a href={`https://tallysight.com/analyst/${analyst.username}/${this.state.sport}/${this.state.orgPicks.pathName}/pick/${topic.pathName}`} target="_blank" rel="noopener noreferrer">
                    <Image width="36" src={pick.pickUrl}
                        style={{ objectFit: "cover" }}
                    />
                </a>
                <br></br>
                <small className="number text-uppercase">
                    {/* Show and hide based upon if they have a lock for this pick */}
                    {pick.lock && <span>🔒</span>}
                    {/* end icon */}
                    {pick.pickAbbrevation !== null && pick.pickAbbrevation !== undefined ? pick.pickAbbrevation : pick.pickName}
                    {(pick.odds && pick.odds !== 0.1) ? ` (${pick.odds > 0 ? "+" : ""}${pick.odds})` : ""}
                </small>
            </span>
        )
    }

    /**
     * Generates the icon of the spread pick
     * depending on it's status 
     */
    generateSpreadPickIcon(pick, topic) {
        const analyst = this.state.orgPicks.analystRecords.find(e => e.id === pick.analystId)
        if (pick.resolved) {
            if (pick.tie) {
                return (
                    <a href={`https://tallysight.com/analyst/${analyst.username}/${this.state.sport}/${this.state.orgPicks.pathName}/pick/${topic.pathName}`} target="_blank" rel="noopener noreferrer">
                        <span>
                            <Image width="36"
                                src={pick.pickUrl}
                                style={{ objectFit: "cover" }}
                            />
                            <br></br>
                            <small>
                                <span className="number text-uppercase">
                                    {pick.lock && <span>🔒</span>}
                                    {pick.pickAbbrevation} {pick.line > 0 ? "+" + pick.line : pick.line === 0 ? "PK" : pick.line}</span><i className="fas fa-minus-circle text-muted"></i>
                            </small>
                        </span>
                    </a>
                )
            }
            if (pick.correct) {
                return (
                    <a href={`https://tallysight.com/analyst/${analyst.username}/${this.state.sport}/${this.state.orgPicks.pathName}/pick/${topic.pathName}`} target="_blank" rel="noopener noreferrer">
                        <span>
                            <Image width="36"
                                src={pick.pickUrl}
                                style={{ objectFit: "cover" }}
                            />
                            <br></br>
                            <small className="number text-uppercase">
                                {pick.lock && <span>🔒</span>}
                                {pick.pickAbbrevation} {pick.line > 0 ? "+" + pick.line : pick.line === 0 ? "PK" : pick.line} <i className="fas fa-check-circle text-success"></i><span>
                                </span>
                            </small>
                        </span>
                    </a>
                )
            }
            return (
                <a href={`https://tallysight.com/analyst/${analyst.username}/${this.state.sport}/${this.state.orgPicks.pathName}/pick/${topic.pathName}`} target="_blank" rel="noopener noreferrer">
                    <Image width="36"
                        src={pick.pickUrl}
                        className="opacity-50"
                        style={{ objectFit: "cover" }}
                    />
                    <br></br>
                    <span>
                        <small className="text-muted number text-uppercase">
                            {pick.lock && <span>🔒</span>}
                            {pick.pickAbbrevation} {pick.line > 0 ? "+" + pick.line : pick.line === 0 ? "PK" : pick.line}
                        </small>
                    </span>
                </a>
            )
        }
        return (
            <a href={`https://tallysight.com/analyst/${analyst.username}/${this.state.sport}/${this.state.orgPicks.pathName}/pick/${topic.pathName}`} target="_blank" rel="noopener noreferrer">
                <span>
                    <Image width="36"
                        src={pick.pickUrl}
                        style={{ objectFit: "cover" }}
                    />
                    <br></br>
                    <small className="number text-uppercase">
                        {pick.lock && <span>🔒</span>}
                        {pick.pickAbbrevation} {pick.line > 0 ? "+" + pick.line : pick.line === 0 ? "PK" : pick.line}
                    </small>
                </span>
            </a>
        )
    }


    processSpreadRowPick(pick, topic) {
        // If no pick for the analyst on this row
        if (!pick) {
            return (<td></td>)
        }
        return (
            <td className="align-middle text-center">
                <span>
                    {this.generateSpreadPickIcon(pick, topic)}
                </span>
            </td>
        )
    }

    displayResolvedOverUnderPickStatus(topic, pick) {
        const analyst = this.state.orgPicks.analystRecords.find(e => e.id === pick.analystId)
        if (pick.tie) {
            if (pick.over) {
                return (
                    <a href={`https://tallysight.com/analyst/${analyst.username}/${this.state.sport}/${this.state.orgPicks.pathName}/pick/${topic.pathName}`} target="_blank" rel="noopener noreferrer">
                        <span>
                            {pick.lock && <span>🔒</span>}
                            <i className="fas fa-check-circle text-success"></i>
                            <br></br>
                            <small className="text-muted number text-uppercase">Over {pick.line} (Push)</small>
                        </span>
                    </a>
                )
            }
            return (
                <a href={`https://tallysight.com/analyst/${analyst.username}/${this.state.sport}/${this.state.orgPicks.pathName}/pick/${topic.pathName}`} target="_blank" rel="noopener noreferrer">
                    <span>
                        {pick.lock && <span>🔒</span>}
                        <i className="fas fa-minus-circle text-muted"></i>
                        <br></br>
                        <small className="text-muted number text-uppercase">Under {pick.line} (Push)</small>
                    </span>
                </a>
            )
        }
        else if (pick.over) {
            if (pick.correct) {
                return (
                    <a href={`https://tallysight.com/analyst/${analyst.username}/${this.state.sport}/${this.state.orgPicks.pathName}/pick/${topic.pathName}`} target="_blank" rel="noopener noreferrer">
                        <span>
                            {pick.lock && <span>🔒</span>}
                            <i className="fas fa-check-circle text-success"></i>
                            <br></br>
                            <small className="number text-uppercase">Over {pick.line}</small>
                        </span>
                    </a>
                )
            }
            return (
                <a href={`https://tallysight.com/analyst/${analyst.username}/${this.state.sport}/${this.state.orgPicks.pathName}/pick/${topic.pathName}`} target="_blank" rel="noopener noreferrer">
                    <span>
                        {pick.lock && <span>🔒</span>}
                        <i className="fas fa-minus-circle text-muted"></i>
                        <br></br>
                        <small className="text-muted number text-uppercase">Over {pick.line}</small>
                    </span>
                </a>
            )
        }
        else if (pick.under) {
            if (pick.correct) {
                return (
                    <a href={`https://tallysight.com/analyst/${analyst.username}/${this.state.sport}/${this.state.orgPicks.pathName}/pick/${topic.pathName}`} target="_blank" rel="noopener noreferrer">
                        <span>
                            {pick.lock && <span>🔒</span>}
                            <i className="fas fa-check-circle text-success"></i>
                            <br></br>
                            <small className="number text-uppercase">Under {pick.line}</small>
                        </span>
                    </a>
                )
            }
            return (
                <a href={`https://tallysight.com/analyst/${analyst.username}/${this.state.sport}/${this.state.orgPicks.pathName}/pick/${topic.pathName}`} target="_blank" rel="noopener noreferrer">
                    <span>
                        {pick.lock && <span>🔒</span>}
                        <i className="fas fa-minus-circle text-muted"></i>
                        <br></br>
                        <small className="text-muted number text-uppercase">Under {pick.line}</small>
                    </span>
                </a>
            )
        }
    }

    displayUnResolvedOverUnderPickStatus(topic, pick) {
        const analyst = this.state.orgPicks.analystRecords.find(e => e.id === pick.analystId)
        if (pick.over) {
            return (
                <a href={`https://tallysight.com/analyst/${analyst.username}/${this.state.sport}/${this.state.orgPicks.pathName}/pick/${topic.pathName}`} target="_blank" rel="noopener noreferrer">
                    <span> <small className="number text-uppercase">O{pick.line} </small></span>
                </a>
            )
        }
        if (pick.under) {
            return (
                <a href={`https://tallysight.com/analyst/${analyst.username}/${this.state.sport}/${this.state.orgPicks.pathName}/pick/${topic.pathName}`} target="_blank" rel="noopener noreferrer">
                    <span> <small className="number text-uppercase">U{pick.line} </small></span>
                </a>
            )
        }
    }

    processOverUnderRowPick(topic, pick) {
        // If no pick for the analyst on this row
        if (!pick) {
            return (<td></td>)
        }
        return (
            <td className="align-middle text-center">
                {pick.resolved ?
                    (
                        this.displayResolvedOverUnderPickStatus(topic, pick)
                    ) : (
                        this.displayUnResolvedOverUnderPickStatus(topic, pick)
                    )
                }
            </td>
        )
    }

    /**
     * Generates the second column of either Spread or the Over/Under depending on 
     * betting data type. No additional column is generated for a StraightUp pick
     */
    // generateBetTypeColumn(topic) {
    //     if (this.state.currentBetType === 'overUnder') {
    //         return (
    //             <td className="align-middle text-center table-active">
    //                 <span><small className="number text-uppercase">{topic.over}</small></span>
    //             </td>
    //         )
    //     }
    //     if (this.state.currentBetType === 'spread') {
    //         return (
    //             <td className="align-middle text-center table-active">
    //                 <span><small className="number text-uppercase">{topic.homeAbbrev} {topic.homeSpread > 0 ? "+" + topic.homeSpread : topic.homeSpread === 0 ? "PK" : topic.homeSpread}</small></span>
    //             </td>
    //         )
    //     }
    // }

    generateTopicResult(topic) {
        if (topic.type === 'game' && (topic.outcome || topic.tie)) {
            return <span><small className="text-uppercase number">(F) {topic.awayScore}-{topic.homeScore}</small></span>
        }
        if (topic.outcome !== null && topic.outcome !== undefined) {
            return (<small className="number text-uppercase">
                <Image width="24"
                    className="mr-1"
                    style={{ objectFit: "cover" }}
                    src={topic.outcome.icon_url} />
                {topic.outcome.name}
            </small>)
        }
    }
    /**
     * 
     * @param {String} topicId - Id of the topic
     * @param {Dict} value - A containing information on the topic
     */

    processRowTopic(topicId, value) {
        return (
            <Fragment key={topicId}>
                <td className="align-middle text-center">
                    <a href={`https://tallysight.com/${this.state.sport}/${this.state.orgPicks.pathName}/${value.type === "regular" ? "future" : "game"}/${value.pathName}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        title="See breakdown on Tallysight">
                        <p className="m-0 effra-bold small">{value.topicName}</p>
                        {this.generateTopicResult(value)}
                        {value.game_start && (
                            <span className="small text-muted">{moment(value.game_start).format('lll')}
                            </span>
                        )
                        }
                    </a>
                </td>
                {/* {this.generateBetTypeColumn(value)} */}
            </Fragment >
        )
    }

    /**
     * Generates a hash of the picks 
     * mapping analystId to pick
     */

    getPicksHash(picks) {
        let picksHash = {}
        for (let pick of picks) {
            picksHash[pick.analystId] = pick
        }
        return picksHash
    }

    /**
     * Processes all Rows of StraightUp Picks
     */

    processStraightUpPicks(topicEntries) {
        let allRows = []
        for (let [topicId, value] of topicEntries) {
            if (value.picks.length > 0) {
                let rowData = []
                let picksHash = this.getPicksHash(value.picks)
                rowData.push(this.processRowTopic(topicId, value))
                for (const analyst of this.state.orgPicks.analystRecords) {
                    rowData.push(
                        this.processRowPick(picksHash[analyst.id], value)
                    )
                }
                allRows.push(<tr key={topicId}>{rowData}</tr>)
            }
        }
        return allRows
    }

    /**
     * Processes all Rows of Spread Picks
     */
    processSpreadPicks(topicEntries) {
        let allRows = []
        for (let [topicId, value] of topicEntries) {
            if (value.picks.length > 0) {
                let rowData = []
                let picksHash = this.getPicksHash(value.picks)
                rowData.push(this.processRowTopic(topicId, value))
                for (const analyst of this.state.orgPicks.analystRecords) {
                    rowData.push(
                        this.processSpreadRowPick(picksHash[analyst.id], value)
                    )
                }
                allRows.push(<tr>{rowData}</tr>)
            }
        }
        return allRows
    }

    /**
     * Processes all Rows of Over/Under Picks
     */
    processOverUnderPicks(topicEntries) {
        let allRows = []
        for (let [topicId, topic] of topicEntries) {
            if (topic.picks.length > 0) {
                let rowData = []
                let picksHash = this.getPicksHash(topic.picks)
                rowData.push(this.processRowTopic(topicId, topic))
                for (const analyst of this.state.orgPicks.analystRecords) {
                    rowData.push(
                        this.processOverUnderRowPick(topic, picksHash[analyst.id])
                    )
                }
                allRows.push(<tr>{rowData}</tr>)
            }
        }
        return allRows
    }

    /**
     * Renders all picks for a topic in
     * a table row
     */
    renderTopicRows() {
        let topicEntries = Object.entries(this.state.orgPicks.topics).filter(([id, topic]) => {
            if (this.state.daily && this.state.dates.length > 0 && this.state.selectedDate !== "all") {
                return moment(topic.game_start || topic.outcomeDate).format("ll") === this.state.selectedDate
            }

            return true
        })
        if (this.state.showTopics !== "all") {
            let newTopicEntries = []
            let topicCheck = this.state.showTopics.split(",")
            for (let topic of topicEntries) {
                if (topicCheck.includes(topic[0].slice(topic[0].length - 4))) {
                    newTopicEntries.push(topic)
                }
            }
            topicEntries = newTopicEntries
        }
        if (this.state.currentBetType === 'straightUp') {
            return this.processStraightUpPicks(topicEntries)
        }
        if (this.state.currentBetType === 'spread') {
            return this.processSpreadPicks(topicEntries)
        }
        if (this.state.currentBetType === 'overUnder') {
            return this.processOverUnderPicks(topicEntries)
        }
    }

    /**
     * Generates the profile headers of everyone who 
     * made a pic
     */
    renderProfileHeader() {
        return this.state.orgPicks.analystRecords.map((analyst) => {
            return (
                <th key={analyst.id} className="align-middle expert-header">
                    <a href={"https://tallysight.com/expert/" + analyst.username}
                        target="_blank"
                        title="View profile on Tallysight"
                        rel="noopener noreferrer">
                        <Image width={36} height={36} src={analyst.avatarUrl} className="mb-2" roundedCircle style={{ objectFit: "cover" }} />
                        <br />
                        <p className="small m-0 effra-bold pull-left" style={{ lineHeight: "14px" }}>
                            {analyst.name}
                        </p>
                    </a>
                </th>
            )
        })
    }

    renderTally() {
        let tallies = []
        // Add empty table column for spreads and over/under
        // Column padding for non straight up picks
        // if (this.state.currentBetType !== 'straightUp') {
        //     tallies.push(<th className="table-active"></th>)
        // }
        for (let analyst of this.state.orgPicks.analystRecords) {
            let tallyPercent = ((analyst.correct / analyst.total) * 100)
            tallyPercent = tallyPercent || 0
            tallies.push(
                <th key={analyst._id + "tally"} className="slim bg-light">
                    <small>{analyst.correct}-{(analyst.total - (analyst.correct + analyst.tie))}-{analyst.tie} <span className="font-weight-bold">({Math.round(tallyPercent)}%)</span></small>
                </th>
            )
        }
        return tallies
    }

    renderOverallScores() {
        let tallies = []
        // Column padding for non straight up picks
        // if (this.state.currentBetType !== 'straightUp') {
        //     tallies.push(<th className="table-active"></th>)
        // }
        // eslint-disable-next-line
        for (let [index, value] of Object.entries(this.state.orgPicks.analystRecords)) {
            let overallPercent = ((value.overallCorrect / value.overallCount) * 100)
            overallPercent = overallPercent || 0
            tallies.push(
                <th key={index} className="slim bg-light">
                    <small>
                        {value.overallCorrect}-{value.overallCount - (value.overallCorrect + value.overallTie)}-{value.overallTie} <span className="font-weight-bold">({Math.round(overallPercent)}%)</span>
                    </small>
                </th>
            )
        }
        return tallies
    }

    /**
     * This shows additional header column such 
     * as the spread or over/under which may need to 
     * be shown to users
     */

    // showAdditionalTableColumn() {
    //     if (this.state.currentBetType === 'spread') {
    //         return (
    //             <th className="align-middle">
    //                 <small className="text-uppercase number">Spread</small>
    //             </th>
    //         )
    //     }
    //     if (this.state.currentBetType === 'overUnder') {
    //         return (
    //             <th className="align-middle">
    //                 <small className="text-uppercase number">O/U</small>
    //             </th>
    //         )
    //     }
    // }

    /**
     * Generates the pick buttons that are availble on a particular event
     */

    generatePickTypesButton() {
        return (
            <ButtonToolbar className="d-flex w-100">
                {this.state.showTogglePickType && !this.state.showTogglePickTypeQuery && this.state.show.length > 1 ?
                    <ToggleButtonGroup type="radio" name="options" defaultValue={this.state.defaultToggleKey} style={{ width: "100%" }}>
                        {this.state.availablePickTypes.straightUp && this.state.show.includes("0") ? (
                            <ToggleButton variant="light"
                                value={1}
                                size="sm"
                                className="effra-bold text-uppercase"
                                onClick={this.handleStraightUpClick}>Winner
                            </ToggleButton>
                        ) : (<span></span>)}
                        {this.state.availablePickTypes.spread && this.state.show.includes("1") ? (
                            <ToggleButton variant="light"
                                value={2}
                                size="sm"
                                className="effra-bold text-uppercase"
                                onClick={this.handleSpreadsClick}>Spread
                            </ToggleButton>
                        ) : (<span></span>)}
                        {this.state.availablePickTypes.overUnder && this.state.show.includes("2") ? (
                            <ToggleButton variant="light"
                                value={3}
                                size="sm"
                                className="effra-bold text-uppercase"
                                onClick={this.handleOverUnderClick}>O/U
                            </ToggleButton>
                        ) : (<span></span>)}
                    </ToggleButtonGroup>
                    : ""}
            </ButtonToolbar>
        )
    }

    componentDidMount() {
        const { sport, event, org } = this.props.match.params
        let query = this.props.location.search
        let queryObject = {}
        if (query) {
            queryObject = JSON.parse('{"' + decodeURI(query.slice(1)).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"') + '"}')
            for (let key in queryObject) {
                if (queryObject[key] === "true") {
                    queryObject[key] = true
                } else if (queryObject[key] === "false") {
                    queryObject[key] = false
                }
            }
            if (!queryObject.eventFilter) {
                queryObject.eventFilter = false
            }
            if (!queryObject.record) {
                queryObject.record = false
            }
            if (!queryObject.show) {
                queryObject.show = "012"
            }
            if (!queryObject.topics) {
                queryObject.topics = "all"
            }
            if (queryObject.daily) {
                queryObject.daily = queryObject.daily === "1"
            }
        }
        else {
            queryObject = {
                hide: null,
                showTogglePickTypeQuery: false,
                eventFilter: false,
                type: "straightUp",
                record: true,
                show: "012",
                topics: "all",
                daily: false
            }
        }

        this.setState({
            showTogglePickTypeQuery: queryObject.dontShow,
            eventFilter: queryObject.eventFilter,
            record: queryObject.record,
            sport,
            showTopics: queryObject.topics,
            show: queryObject.show,
            daily: queryObject.daily,
            event_id: event,
            org_id: org
        }, () => {
            if (queryObject.type === "overUnder") {
                this.getOrgOUPicks(event, org)
                this.setState({
                    defaultToggleKey: 3
                })
            } else if (queryObject.type === "spread") {
                this.getOrgSpreadPicks(event, org)
                this.setState({
                    defaultToggleKey: 2
                })
            } else {
                this.getOrgPicks(event, org)
                this.setState({
                    defaultToggleKey: 1
                })
            }
            this.getOrg(org)
            // this.getFlatEventsWhereOrgAnalystParticipated(sport, org)
            this.getOrgEventPickTypes(event, org)
        })
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.state.orgPicks !== prevState.orgPicks) {
            this.setState({ orgPicks: this.state.orgPicks })
        }
    }

    render() {
        if ((this.state.org === null) ||
            (this.state.orgPicks === null) ||
            (this.state.availablePickTypes === null) ||
            (this.state.events === null)
        ) {
            return (<div className="text-center vertically-center align-self-center">
                <Spinner variant="primary" animation="border" role="status" style={{ width: "3rem", height: "3rem" }}>
                    <span className="sr-only">Loading...</span>
                </Spinner>
                <p className="effra-bold mt-2">Loading Staff Picks...</p>
            </div>)
        }
        else {
            // let eventOptions = []
            // for (let event of this.state.events) {
            //     eventOptions.push(<option value={event._id}>{event.name}</option>)
            // }
            return (
                <div className="vh-100">
                    <div className="top-scrollbar"></div>
                    <Card>
                        <Card.Header as="h6">
                            <Row className="justify-content-md-center">
                                <Col>
                                    {this.state.daily && this.state.dates.length > 0 &&
                                        <Form.Control
                                            as="select"
                                            size="sm"
                                            onChange={(e) => this.dateChangeHandler(e.target.value)}
                                            value={this.state.selectedDate}
                                            className="float-right mb-3 align-self-center"
                                            style={{ width: "150px", textOverflow: "ellipsis" }}
                                        >
                                            <option value="all">All</option>
                                            {this.state.dates.map(date => <option value={date} key={date}>{date}</option>)}
                                        </Form.Control>
                                    }
                                    {this.state.sport && this.state.eventName && <a className="number align-self-center text-uppercase mr-3 lh-28" href={`https://tallysight.com/${this.state.sport}/${this.state.orgPicks.pathName}`} target="_blank" rel="noopener noreferrer">{this.state.sport} {this.state.eventName}</a>}
                                    {this.generatePickTypesButton()}
                                </Col>
                            </Row>
                        </Card.Header>
                        <Card.Body className="p-0 border-0">
                            <div className="container-fluid p-0 overflow">
                                <Table
                                    bordered
                                    responsive="sm"
                                    className="mb-0"
                                >
                                    <thead>
                                        <tr align="center">
                                            <th className="align-middle">
                                                <Image src={this.state.org.logo_url} width={60} style={{ marginBottom: 4, marginTop: 4 }} />
                                            </th>
                                            {this.renderProfileHeader()}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.renderTopicRows()}
                                        <tr align="center">
                                            <th className="slim bg-light">
                                                <small className="effra-bold">Tally</small>
                                            </th>
                                            {this.renderTally()}
                                        </tr>
                                        {this.state.record ?
                                            <tr align="center">
                                                <th className="slim bg-light">
                                                    <small className="effra-bold">Overall</small>
                                                </th>
                                                {this.renderOverallScores()}
                                            </tr>
                                            : ""}
                                    </tbody>
                                </Table>
                            </div>
                        </Card.Body>
                        <Card.Footer>
                            <a href={`https://tallysight.com/${this.state.sport}/${this.state.orgPicks.pathName}`} target="_blank" rel="noopener noreferrer">
                                <Container>
                                    <Row>
                                        <Col xs={12} className="text-center align-self-center">
                                            <p className="d-inline m-0"><span className="small">Powered by </span>
                                                <Image src={Logo} width={24} className="d-inline ml-1" /> <span className="effra-bold d-inline title">tallysight</span></p>
                                        </Col>
                                    </Row>
                                </Container>
                            </a>
                        </Card.Footer>
                    </Card>
                </div>
            );
        }
    }

}
